import React from 'react';
import { Container, Row, Col, Card, CardBody, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';

const Pages404 = () => {
    document.title = "Error 404 | Lexa - Responsive Bootstrap 5 Admin Dashboard";
    const navigate = useNavigate();

    return (
        <React.Fragment>
            <div
                className="d-flex align-items-center justify-content-center vh-100"
                style={{ background: 'linear-gradient(135deg, #667eea, #764ba2)' }}
            >
                <Container>
                    <Row className="justify-content-center">
                        <Col md="8" lg="6" xl="5">
                            <Card className="shadow-lg border-0">
                                <CardBody className="text-center p-5">
                                    <h1 className="display-1 fw-bold text-black">
                                        404
                                    </h1>
                                    <h3 className="text-black"
                                        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                                    >
                                        <i style={{ fontSize: '1em' }} className="mdi mdi-link-off me-1"></i>
                                        Page Not Found!
                                    </h3>
                                    <p className="text-black-50 mb-4">
                                        Oops! The page you're looking for doesn't exist. You may have mistyped the address or the page may have moved.
                                    </p>
                                    <div>
                                        <Button
                                            color="light"
                                            style={{ backgroundColor: '#667eea', color: '#fff' }}
                                            onClick={() => navigate(-1)}
                                        >
                                            Go Back
                                        </Button>
                                        <Button
                                            className="me-2 text-black ms-2"
                                            color="light"
                                            outline
                                            onClick={() => navigate('/scanlist')}
                                            style={{
                                                border: '1px solid gray'
                                            }}
                                        >
                                            Go To Scan List
                                        </Button>
                                    </div>
                                </CardBody>
                            </Card>
                            <div className="mt-4 text-center text-white-50">
                                <small>
                                   © 2025 - Bravent
                                </small>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Pages404;